import { Grid } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import useTheme from '@material-ui/core/styles/useTheme';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { useAuth } from 'src/app/infra/auth';
import { useChats } from 'src/app/infra/chats';
import { useEvents } from 'src/app/infra/events';
import { useRoute } from 'src/app/infra/routes';
import { postLogin } from 'src/app/services/accounts';
import { getEntrada, getPreLogin, getVotacao } from 'src/app/services/votacao';
import { BtnLoading, Loading, Msgbox, Optional } from 'src/app/shared/utils';
import { Token } from 'src/app/types/accounts';
import {
  Entrada,
  PreLogin,
  TipoExibicaoChat,
  VotacaoItem
} from 'src/app/types/votacao';
import { useWrapper } from 'src/utils/axios';
import { loadCookie, removeCookie } from 'src/utils/cookie';
import HubertLogo from './assets/even/logoHubert.png';
import Assembly from './components/assembly';
import ConsultProcuration from './components/consultProcuration';
import ForgotPassword from './components/forgotPassword';
import SendProcuration from './components/sendProcuration';
import Terms from './components/terms';
import ArtLogin from './svg/logo_hubert.svg';

const View = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  padding: 2rem;
  width: 100%;
  min-height: 100vh;
  background-repeat: no-repeat;
  background-size: 100%;
  background-size: cover;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 0;
  }
`;

const SignOff = styled(Button)`
  width: 100px;
  min-height: 24px;
  margin-left: -1rem;
  color: #083f8b;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const ColumnHideOnMobile = styled(Column)`
  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`;

export const Wrapper = styled.div<{ noMarginLeft?: boolean }>`
  display: flex;
  flex-direction: column;
  max-width: 500px;
  margin: auto auto auto ${({ noMarginLeft }) => (noMarginLeft ? '0' : 'auto')};
  padding: 0 42px;
`;

export const Title = styled(Typography)`
  font-weight: bold;
  text-align: center;
  margin-top: 42px;
`;

export const Text = styled(Typography)`
  text-align: right;
  color: #919191;
`;

export const TextCond = styled(Typography)`
  text-align: left;
  color: #919191;
`;

export const TextWhite = styled(Typography)`
  font-size: 15px;
  color: white;
`;

export const TitleLeft = styled(Typography)`
  font-weight: bold;
  padding: 8px 0px;
  color: white;
`;

export const Div = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 4rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;

  > div {
    margin-top: 8px;
  }

  > div > button {
    margin-top: 16px;
  }
`;

export const HeaderLogoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 24px;
  position: absolute;
  top: 24px;
  right: 24px;
`;

const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const OptionButton = styled(Button)`
  min-height: 0px;
  height: 48px;
`;

const CustomInput = styled(OutlinedInput)`
  > input {
    color: ${({ color }) => color};
  }
  > fieldset {
    border-color: ${({ color }) => color};
  }
`;

const ErrorContainer = styled.div`
  display: flex;
  min-height: 100vh;
  width: 100vw;
`;

const ErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;

  span {
    font-size: 18px;
    text-align: center;
  }

  p {
    margin-top: 16px;
    color: #646464;
  }
`;

export default () => {
  const { authOn, authOff } = useAuth();
  const {
    params: { condominio, token },
    query: { redirect }
  } = useRoute();
  const events = useEvents();
  const { mountBlipChat, mountMovideskChat, openMovideskChat, openBlipChat } =
    useChats();
  const response = useWrapper<Token>();
  const preLoginResponse = useWrapper<PreLogin>();
  const votacaoItem = useWrapper<VotacaoItem>();
  const entrada = useWrapper<Entrada>();

  const [unidade, setUnidade] = useState('');
  const [cpfCnpj, setCpfCnpj] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showAssembly, setShowAssembly] = useState(false);
  const [showSendProcuration, setShowSendProcuration] = useState(false);
  const [showConsultProcuration, setShowConsultProcuration] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  let [showHome] = useState(false);
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const [customLayout, setCustomLayout] = useState(new Object());
  const [isCustom, setIsCustom] = useState(false);
  const [showForgotPassword, setshowForgotPassword] = useState(false);
  const [show, setShow] = useState(false);
  const [silentLogin, setSilentLogin] = useState(false);

  const login = (preToken?: string) => {
    let cpf = cpfCnpj;
    let unid = unidade;
    let terms = true;

    //? possibilidade de login silencioso atraves de um token valido
    if (preToken) {
      try {
        const data = atob(preToken).split(':');
        if (data.length) {
          unid = data[0];
          cpf = data[1];
          terms = false;
        }
      } catch {
        //
      }
    }

    response.exec(
      postLogin({ cpfCnpj: cpf, unidade: unid, condominio }),
      () => {
        if (terms) {
          setShowTerms(true);
        } else {
          setSilentLogin(true);
        }
      }
    );
    return () => response.cancel();
  };

  const preLogin = () => {
    preLoginResponse.exec(getPreLogin(token), (res) => {
      identidadeVisual(res.identidadeVisual);
      setShow(true);
    });
  };

  const identidadeVisual = (idVisual) => {
    const hasIdVisual = Object.keys(idVisual).length !== 0;
    if (hasIdVisual) {
      setCustomLayout(idVisual);
      setIsCustom(true);
    }
  };

  const signOff = () => {
    authOff();
    response.reset();
    votacaoItem.reset();
    entrada.reset();
    setShowLogin(true);
    setUnidade('');
    setCpfCnpj('');
  };

  const getCodigoVotacao = () => {
    validateLogin();
    votacaoItem.exec(getVotacao(token), (getRes) =>
      response.payload?.unidadeLogin?.tipoUsuario === 4
        ? validateGoHome()
        : getEntradaVotacao(getRes.codigoVotacao)
    );
  };

  const getEntradaVotacao = (codVotacao: number) => {
    entrada.exec(getEntrada(codVotacao), (resEntrada) =>
      validateGoHome(resEntrada.assinatura.codigo)
    );

    return () => entrada.cancel();
  };

  function redirectLogic() {
    if (redirect) {
      events.stop();
      window.location.href = redirect;
      return;
    }
  }

  const validateGoHome = (codAssinatura?: number) => {
    if (codAssinatura || response.payload?.unidadeLogin?.tipoUsuario === 4) {
      redirectLogic();
      showHome = true;
      validateLogin();
    } else {
      setShowLogin(false);
    }
  };

  const validateLogin = () => {
    const resp = response.payload;
    if (resp) {
      authOn({
        token: resp.token,
        expiration: new Date(resp.expiration),
        user: {
          name: resp.nome,
          email: resp.email,
          login: resp.login,
          picture: resp.url_Foto,
          unidade: String(resp.unidadeLogin?.unidade) || unidade,
          outrasUnidades: resp.outrasUnidadesCpfCnpj,
          unidadeLogin: resp.unidadeLogin
        },
        goHome: showHome,
        condominio
      });
    }
  };

  const validateAssembly = (done: boolean) => {
    setShowAssembly(false);
    if (done) {
      showHome = true;
      validateLogin();

      redirectLogic();
    }
  };

  const validateSendProcuration = (done: boolean) => {
    setShowSendProcuration(false);
    if (done) {
      setUnidade('');
      setCpfCnpj('');
      setShowLogin(true);
    }
  };

  const validateConsultProcuration = (done: boolean) => {
    setShowConsultProcuration(false);
    if (done) {
      //validateLogin();
    }
  };

  const validateTerms = (done: boolean) => {
    if (done) {
      const resp = response.payload;
      if (resp && response.valid) {
        getCodigoVotacao();
      }
    }
    setShowTerms(false);
  };

  const validateForgotPassword = (done: boolean) => {
    if (done) {
    }
    setshowForgotPassword(false);
  };

  const openAssembly = () => {
    setShowAssembly(true);
  };

  const openForgotPassword = () => {
    setshowForgotPassword(true);
  };

  const openSendProcuration = () => {
    setShowSendProcuration(true);
  };

  const openConsultProcuration = () => {
    setShowConsultProcuration(true);
  };

  const codVotacao = () => {
    return votacaoItem.payload?.codigoVotacao;
  };

  function scrollToBottom() {
    window.scrollBy(0, 600);
  }

  // const validateLayout = () => {
  //   if(condominio === '2626') {
  //     setCustomLayout(Even);
  //     setIsCustom(true);
  //   }
  //   if(condominio === '7003') {
  //     setCustomLayout(Marajoara);
  //     setIsCustom(true);
  //   }
  //   if(condominio === '7004') {
  //     setCustomLayout(Saude);
  //     setIsCustom(true);
  //   }
  // }

  const customDomainTitleAssembleia = React.useMemo(() => {
    switch (condominio) {
      case '2202':
      case '2271':
        return 'Assembleia';
      default:
        return 'Assembleia Virtual';
    }
  }, [condominio]);

  const hasHelpChat = React.useMemo(() => {
    switch (preLoginResponse.payload?.tipoExibicaoChat) {
      case TipoExibicaoChat.BlipChat:
      case TipoExibicaoChat.BlipChatApenasAreaDeslogada:
      case TipoExibicaoChat.MovideskChat:
      case TipoExibicaoChat.MovideskChatApenasAreaDeslogada:
        return true;
      default:
        return false;
    }
  }, [preLoginResponse.payload]);

  function handleHelpChat() {
    switch (preLoginResponse.payload?.tipoExibicaoChat) {
      case TipoExibicaoChat.BlipChat:
      case TipoExibicaoChat.BlipChatApenasAreaDeslogada:
        openBlipChat();
        break;
      case TipoExibicaoChat.MovideskChat:
      case TipoExibicaoChat.MovideskChatApenasAreaDeslogada:
        openMovideskChat();
        break;
    }
  }

  useEffect(() => {
    //validateLayout();
    preLogin();
    return () => preLoginResponse.cancel();
  }, []);

  //? possibilidade de login silencioso atraves de um token valido
  useEffect(() => {
    const PRETOKEN_KEY = 'hub.subsites.pretoken' + condominio;

    const preToken = loadCookie(PRETOKEN_KEY);
    if (preToken) {
      login(preToken);
      removeCookie(PRETOKEN_KEY);
    }
  }, []);

  //? possibilidade de login silencioso atraves de um token valido
  useEffect(() => {
    if (silentLogin && response.payload) {
      getCodigoVotacao();
      setSilentLogin(false);
    }
  }, [silentLogin, response.payload]);

  useEffect(() => {
    if (preLoginResponse.payload?.tipoExibicaoChat) {
      switch (preLoginResponse.payload?.tipoExibicaoChat) {
        case TipoExibicaoChat.BlipChat:
        case TipoExibicaoChat.BlipChatApenasAreaDeslogada:
          mountBlipChat();
          break;
        case TipoExibicaoChat.MovideskChat:
        case TipoExibicaoChat.MovideskChatApenasAreaDeslogada:
          mountMovideskChat();
          break;
      }
    }
  }, [preLoginResponse.payload]);

  const FormLogin = () => {
    return (
      <Form
        onSubmit={(e) => {
          e?.preventDefault();
          login();
        }}
      >
        <FormControl variant="outlined" fullWidth>
          <InputLabel
            htmlFor="unid"
            style={{
              color:
                isCustom && !!customLayout['fontColor']
                  ? customLayout['fontColor']
                  : '#000'
            }}
          >
            {preLoginResponse.payload?.tipoLogin === 0 ? 'Unidade' : 'E-mail'}
          </InputLabel>
          <CustomInput
            id="unid"
            label={
              preLoginResponse.payload?.tipoLogin === 0 ? 'Unidade' : 'E-mail'
            }
            color={
              isCustom && !!customLayout['fontColor']
                ? customLayout['fontColor']
                : '#000'
            }
            type="text"
            value={unidade}
            onChange={(e) => setUnidade(e.target.value.toUpperCase())}
          />
        </FormControl>
        <FormControl variant="outlined" fullWidth>
          <InputLabel
            htmlFor="pass"
            style={{
              color:
                isCustom && !!customLayout['fontColor']
                  ? customLayout['fontColor']
                  : '#000'
            }}
          >
            {preLoginResponse.payload?.tipoLogin === 0 ? 'CPF/CNPJ' : 'Senha'}
          </InputLabel>
          <CustomInput
            id="pass"
            label={
              preLoginResponse.payload?.tipoLogin === 0 ? 'Cpf/Cnpj' : 'Senha'
            }
            color={
              isCustom && !!customLayout['fontColor']
                ? customLayout['fontColor']
                : '#000'
            }
            type={showPassword ? 'text' : 'password'}
            value={cpfCnpj}
            onChange={(e) => setCpfCnpj(e.target.value)}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword(!showPassword)}
                  edge="end"
                >
                  {showPassword ? (
                    <Icon
                      style={{
                        color: isCustom ? customLayout['fontColor'] : '#000'
                      }}
                    >
                      visibility_off
                    </Icon>
                  ) : (
                    <Icon
                      style={{
                        color: isCustom ? customLayout['fontColor'] : '#000'
                      }}
                    >
                      visibility
                    </Icon>
                  )}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <Options>
          <BtnLoading
            type="submit"
            disabled={!cpfCnpj || !unidade}
            loading={response.loading}
            customColor
            fontColor={
              customLayout['loginButtonBackground'] < '#d3d3d3'
                ? '#fff'
                : '#000'
            }
            backgroundColor={customLayout['loginButtonBackground']}
          >
            ENTRAR
          </BtnLoading>
          {hasHelpChat && (
            <OptionButton
              color="inherit"
              variant="text"
              fullWidth
              onClick={handleHelpChat}
            >
              <Typography
                variant="caption"
                style={{
                  fontWeight: 'bold',
                  color: !!customLayout['fontColor']
                    ? customLayout['fontColor']
                    : '#343A40'
                }}
              >
                Ajuda via chat
              </Typography>
            </OptionButton>
          )}
        </Options>
        {isCustom && isMobile ? (
          <KeyboardArrowDownIcon
            style={{ color: 'white', width: '10em', height: '2em' }}
            onClick={scrollToBottom}
          />
        ) : (
          <img
            src="/assets/img/digicert-logo.png"
            alt="art tela de login"
            width="72px"
            style={{
              marginTop: '1.4rem',
              marginBottom:
                preLoginResponse.payload?.tipoLogin === 1 ? '0px' : '1rem'
            }}
          />
        )}

        <Optional valid={preLoginResponse.payload?.tipoLogin === 1}>
          <a
            onClick={() => openForgotPassword()}
            style={{ textDecoration: 'underline', cursor: 'pointer' }}
          >
            esqueci a senha
          </a>
        </Optional>
      </Form>
    );
  };

  const AfterLogin = () => (
    <Div>
      <Optional
        valid={
          entrada.payload?.tipoUsuario === 1 &&
          response.payload?.unidadeLogin?.situacao === 2 &&
          response.payload?.unidadeLogin?.tipoUsuario === 1
        }
      >
        <Button
          variant="outlined"
          onClick={() => openAssembly()}
          style={{ color: isCustom ? customLayout['fontColor'] : '#000' }}
        >
          Acessar Assembleia
        </Button>
        <Button
          variant="outlined"
          onClick={() => openSendProcuration()}
          style={{
            marginTop: '6px',
            marginBottom: '6px',
            color: isCustom ? customLayout['fontColor'] : '#000'
          }}
        >
          Enviar Procuração
        </Button>
        <Button
          variant="outlined"
          onClick={() => openConsultProcuration()}
          style={{ color: isCustom ? customLayout['fontColor'] : '#000' }}
        >
          Consultar Procuração
        </Button>
      </Optional>
      <Optional
        valid={
          entrada.payload?.tipoUsuario === 2 &&
          response.payload?.unidadeLogin?.situacao === 2 &&
          response.payload?.unidadeLogin?.tipoUsuario === 2
        }
      >
        <Button variant="outlined" onClick={() => openAssembly()}>
          Acessar Assembleia
        </Button>
      </Optional>
    </Div>
  );

  return show ? (
    <View
      style={
        !isCustom
          ? { backgroundColor: '#fff' }
          : isCustom && !isMobile
          ? {
              backgroundImage: `url(${customLayout['backgroundImage']})`,
              width: '100%',
              height: !showLogin ? '100%' : ''
            }
          : { backgroundColor: customLayout['bkgColor2'] }
      }
    >
      <Grid
        container
        spacing={isMobile ? undefined : 3}
        style={{
          paddingTop: isCustom && isMobile && showLogin ? '22%' : '0%'
        }}
      >
        <Grid
          item
          xs={12}
          sm={showLogin ? 6 : 12}
          style={
            !isMobile && showLogin
              ? { padding: '0px', maxWidth: '49%' }
              : { padding: '0px' }
          }
        >
          <Column
            style={{
              backgroundColor: isCustom ? customLayout['bkgColor2'] : '#fff',
              height: isMobile ? '84vh' : '92vh',
              padding: '0px'
            }}
          >
            <Wrapper>
              {!isCustom ? (
                <ColumnHideOnMobile>
                  <img src={ArtLogin} alt="art tela de login" width="320px" />
                </ColumnHideOnMobile>
              ) : null}
              {isCustom || (isCustom && isMobile) ? (
                <img
                  src={
                    customLayout['logoPrincipal']
                      ? customLayout['logoPrincipal']
                      : ArtLogin
                  }
                  alt="art tela de login"
                  width={isMobile ? '240px' : '320px'}
                  style={{ marginTop: '8%' }}
                />
              ) : null}
              <Title
                variant="h4"
                style={{
                  color: !!customLayout['fontColor']
                    ? customLayout['fontColor']
                    : '#083350'
                }}
              >
                {customDomainTitleAssembleia}
              </Title>
              <Optional
                valid={!!condominio && customLayout['showNomeAssembleia']}
              >
                <ColumnHideOnMobile>
                  <TextCond
                    style={{
                      color: isCustom ? customLayout['fontColor'] : '#919191'
                    }}
                  >
                    {preLoginResponse.payload?.condominio.nomeCondominio +
                      ' ' +
                      '(' +
                      condominio +
                      ')'}
                  </TextCond>
                </ColumnHideOnMobile>
              </Optional>
              <Optional valid={!!condominio && !isCustom}>
                <TextCond
                  style={{
                    color: isCustom ? customLayout['fontColor'] : '#919191'
                  }}
                >
                  {preLoginResponse.payload?.condominio.nomeCondominio +
                    ' ' +
                    '(' +
                    condominio +
                    ')'}
                </TextCond>
              </Optional>
              <Optional valid={votacaoItem.valid}>
                <SignOff color="inherit" onClick={signOff}>
                  <Typography
                    variant="caption"
                    style={{
                      fontWeight: 'bold',
                      textDecoration: 'underline',
                      color: isCustom ? customLayout['fontColor'] : '#083F8B'
                    }}
                  >
                    Sair
                  </Typography>
                </SignOff>
              </Optional>
              {showLogin ? FormLogin() : <AfterLogin />}
            </Wrapper>
          </Column>
          <Terms
            open={showTerms}
            handleClose={validateTerms}
            codCond={condominio}
            identidadeVisual={customLayout}
          ></Terms>
          <Assembly
            open={showAssembly}
            handleClose={validateAssembly}
            codigoVotacao={codVotacao()}
            data={response.payload}
            identidadeVisual={customLayout}
          ></Assembly>
          <SendProcuration
            open={showSendProcuration}
            handleClose={validateSendProcuration}
            codigoVotacao={codVotacao()}
            data={response.payload}
            identidadeVisual={customLayout}
            urlModeloProcuracao={preLoginResponse.payload?.urlModeloProcuracao}
          ></SendProcuration>
          <ConsultProcuration
            open={showConsultProcuration}
            handleClose={validateConsultProcuration}
            codigoVotacao={codVotacao()}
          ></ConsultProcuration>
          <ForgotPassword
            open={showForgotPassword}
            identidadeVisual={customLayout}
            handleClose={validateForgotPassword}
          ></ForgotPassword>
          <Loading open={votacaoItem.loading || entrada.loading} hasBackdrop />
          <Msgbox error={response.error} onClose={() => response.reset()} />
          <Msgbox error={entrada.error} onClose={() => entrada.reset()} />
        </Grid>
        <Optional valid={showLogin}>
          {isCustom && !isMobile ? (
            <Grid
              item
              style={{
                backgroundColor: customLayout['bkgColor2'],
                padding: '0.5px'
              }}
            >
              <div
                style={{
                  padding: '0.5px',
                  height: '500px',
                  marginTop: '55px',
                  backgroundColor: customLayout['bkgColor']
                }}
              ></div>
            </Grid>
          ) : null}
          {isCustom && isMobile ? (
            <div
              style={{
                backgroundColor: customLayout['bkgColor'],
                width: '100%',
                paddingTop: '0.5%'
              }}
            ></div>
          ) : null}
        </Optional>
        <Optional valid={showLogin}>
          <Grid item xs={12} sm={6} style={{ padding: '0px' }}>
            <Column
              style={{
                backgroundColor:
                  isCustom && !!customLayout['bkgColor2']
                    ? customLayout['bkgColor2']
                    : '#083350',
                height: isMobile ? '84vh' : '92vh',
                position: 'relative'
              }}
            >
              <Wrapper noMarginLeft>
                <HeaderLogoRow>
                  {isCustom && showLogin ? (
                    <>
                      {customLayout['showLogoHubert'] ? (
                        <img width={124} src={HubertLogo} />
                      ) : null}
                      {customLayout['logoTopoLogin'] ? (
                        <img width={98} src={customLayout['logoTopoLogin']} />
                      ) : null}
                    </>
                  ) : null}
                </HeaderLogoRow>
                <div
                  style={{
                    width: '100%',
                    wordWrap: 'break-word',
                    padding: '16px'
                  }}
                >
                  <TitleLeft style={{ color: customLayout['fontColor'] }}>
                    Veja como acessar com a sua unidade
                  </TitleLeft>
                  <TextWhite style={{ color: customLayout['fontColor'] }}>
                    Para acessar a assembleia, informe o campo unidade da
                    seguinte forma:
                  </TextWhite>
                  <div style={{ padding: '12px 0px' }}>
                    {preLoginResponse.loading ? (
                      <p style={{ fontWeight: 'bold' }}>Carregando...</p>
                    ) : (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: String(
                            preLoginResponse.payload?.htmlHelpLogin
                          )
                        }}
                      ></div>
                    )}
                  </div>
                  <TitleLeft style={{ color: customLayout['fontColor'] }}>
                    Você tem uma Procuração?
                  </TitleLeft>
                  <div>
                    <TextWhite style={{ color: customLayout['fontColor'] }}>
                      Se você é somente Procurador (não tem nenhuma Unidade
                      deste condomínio em seu nome), acesse com a unidade da
                      procuração e o seu CPF no campo senha.
                      <br />
                    </TextWhite>
                    <TextWhite style={{ color: customLayout['fontColor'] }}>
                      Se você é Proprietário e Procurador, acesse normalmente
                      com seus dados e confirme as unidades que seu voto irá
                      representar no momento de assinar a lista de presença.
                      <br />
                      <br />
                      <a
                        style={{
                          color: customLayout['fontColor']
                            ? customLayout['fontColor']
                            : '#fff',
                          fontWeight: 'bold',
                          fontSize: '17px',
                          textDecoration: 'underline',
                          textAlign: 'end'
                        }}
                        href={
                          isCustom && !!customLayout['linkAjuda']
                            ? customLayout['linkAjuda']
                            : 'http://conteudo.hubert.com.br'
                        }
                        target="_blank"
                      >
                        Precisa de mais ajuda? Clique aqui.
                      </a>
                    </TextWhite>
                    <TextWhite></TextWhite>
                  </div>
                </div>
              </Wrapper>
            </Column>
          </Grid>
        </Optional>
      </Grid>
    </View>
  ) : preLoginResponse.error ? (
    <ErrorContainer>
      <ErrorContent>
        <h2>Ops!</h2>
        <span>
          Tivemos um problema ao carregar a votação. Mais detalhes abaixo:
        </span>
        <p>{String(preLoginResponse.error || '').split('|')[0]}</p>
      </ErrorContent>
    </ErrorContainer>
  ) : (
    <Loading open color="primary">
      Carregando...
    </Loading>
  );
};
